/**
 * Références entre objets (2026-11-04) : `features/references/`. Le nom de chaque sorte sert à
 * l'infobulle et au libellé accessible d'une référence non résolue.
 */
export const referencesFr = {
  copied: 'Identifiant copié',
  copyLabel: '{{kind}} {{id}} — copier l’identifiant',
  missing: '{{kind}} introuvable (supprimé ou hors de vos droits)',
  kinds: {
    project: 'Projet',
    job: 'Job',
    workflow: 'Workflow',
    jobRun: 'Run',
    workflowRun: 'Run de workflow',
    identity: 'Identité',
    user: 'Utilisateur',
    principal: 'Utilisateur ou identité',
    group: 'Groupe',
    role: 'Rôle',
    secret: 'Secret',
    application: 'Jeton API',
    identityProvider: 'Fournisseur d’identité',
    infrastructure: 'Infrastructure',
    instanceType: 'Type d’instance',
    bucket: 'Bucket',
    warehouse: 'Entrepôt',
    connection: 'Connexion',
    endpoint: 'Endpoint',
    workspace: 'Espace de travail',
    session: 'Session',
    stream: 'Flux',
    bridge: 'Pont',
    device: 'Appareil',
    runtime: 'Environnement d’exécution',
    runtimeVersion: 'Version d’environnement',
    runtimeBuild: 'Construction',
    firewallRule: 'Règle de pare-feu',
    ticket: 'Ticket',
    graph: 'Graphe',
    glossaryTerm: 'Terme du glossaire',
    llmModel: 'Modèle de langage',
    llmProvider: 'Fournisseur LLM',
    ragIndex: 'Assistant',
    agentPolicy: 'Politique d’agent',
    approval: 'Approbation',
    model: 'Modèle',
    experiment: 'Expérience',
    experimentRun: 'Run d’expérience',
  },
};
